import { Component, Input, ViewChild } from '@angular/core';
import { BarChartComponent } from '../../ui/graphing/bar-chart/bar-chart.component';
import { ReportingService } from '../../../models/reporting/reportingService';

@Component({
  selector: 'app-revenue-chart',
  templateUrl: './revenue-chart.component.html',
  standalone: false,
})
export class RevenueChartComponent {
  @Input() chartType: string = 'bar'; // bar, line
  @Input() merchantId: string | undefined = undefined;
  @Input() interval: string = 'month'; // day, month
  @Input() duration: number = 12;

  @ViewChild('theChart') theChart: BarChartComponent | undefined;

  constructor(private reportingService: ReportingService) {}

  ngAfterViewInit() {
    this.reportingService
      .getRevenueReportData(this.merchantId, this.interval, this.duration)
      .then((reportData) => {
        if (this.theChart) {
          /*
      // for UI demo only!
      let reportData = new Array();
      reportData[0] = {label: "OCT '23", value: 10361.14};
      reportData[1] = {label: "NOV '23", value: 59070.01};
      reportData[2] = {label: "DEC '23", value: 57617.65};
      reportData[3] = {label: "JAN '24", value: 84311.00};
      reportData[4] = {label: "FEB '24", value: 23572.57};
      reportData[5] = {label: "MAR '24", value: 18654.15};
      reportData[6] = {label: "APR '24", value: 11567.37};
      reportData[7] = {label: "MAY '24", value: 52356.41};
      reportData[8] = {label: "JUN '24", value: 49254.35};
      reportData[9] = {label: "JUL '24", value: 32155.54};
      reportData[10] = {label: "AUG '24", value: 8361.14};
      reportData[11] = {label: "SEP '24", value: 28156.54};
      reportData[12] = {label: "OCT '24", value: 8154.89};
*/
          let newData: any[] = [];

          for (var i = 0; i < reportData.length; i++) {
            newData.push({
              year: reportData[i].label,
              count: reportData[i].value,
            });
          }

          this.theChart.setData(newData, {});
        }
      });
  }
}
